import * as React from "react";
const WhatsappLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="none"
    {...props}
  >
    <path
      fill="#4F2E03"
      d="M12.79.002a12.993 12.993 0 0 1 13.079 11.16 12.995 12.995 0 0 1-9.43 14.377 12.987 12.987 0 0 1-8.844-.722l-6.42 1.145A1 1 0 0 1 .083 24.58l1.98-4.566a13.005 13.005 0 0 1 2.188-16.62 12.992 12.992 0 0 1 8.54-3.39Zm.034 2a10.992 10.992 0 0 0-10.75 9.802c-.29 2.663.4 5.341 1.942 7.531a1 1 0 0 1 .1.974l-1.458 3.356 4.896-.872a1 1 0 0 1 .616.087 10.992 10.992 0 0 0 14.027-3.845 11.004 11.004 0 0 0-2.058-14.404 10.99 10.99 0 0 0-7.315-2.629Zm-1.495 8.309c0 .442-.175.866-.488 1.179a1.665 1.665 0 0 1-.623.39 5.668 5.668 0 0 0 1.437 2.439 5.663 5.663 0 0 0 2.437 1.435c.082-.231.213-.444.39-.62l.122-.112a1.666 1.666 0 0 1 1.056-.377h1.333c.387 0 .76.134 1.056.377l.123.111.11.122a1.667 1.667 0 0 1-1.29 2.723H15.66l-.38-.01a7.663 7.663 0 0 1-7.283-7.657V8.978A1.667 1.667 0 0 1 9.663 7.31l.165.009c.327.032.636.16.89.369l.123.11.11.123c.244.297.378.67.378 1.056v1.333Z"
    />
  </svg>
);
export default WhatsappLogo;
